// Nova senha (`spec/17-frontend.md` §8.1). O servidor exige 8 caracteres
// (`resetPasswordBodySchema`), então o formulário exige o mesmo.

import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { api } from '../api/client.ts';
import { errorMessageOf } from '../api/errors.ts';
import { AuthShell, FormError } from '../components/app/auth-shell.tsx';
import { Button } from '../components/ui/button.tsx';
import { Input } from '../components/ui/input.tsx';
import { Label } from '../components/ui/label.tsx';

const searchSchema = z.object({ token: z.string().optional() });

const schema = z.object({
  newPassword: z.string().min(8, 'A senha precisa de pelo menos 8 caracteres'),
});

function ResetPassword() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const [error, setError] = useState<string | undefined>(undefined);
  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: { newPassword: '' },
  });

  const submit = form.handleSubmit(async (values) => {
    setError(undefined);
    try {
      await api('/v1/me/auth/reset-password', {
        method: 'POST',
        body: { token: token ?? '', newPassword: values.newPassword },
      });
      await navigate({ to: '/login' });
    } catch (caught) {
      setError(errorMessageOf(caught));
    }
  });

  if (token === undefined || token === '') {
    return (
      <AuthShell title="Link inválido" description="Peça um link novo de recuperação.">
        <Button asChild variant="outline" className="w-full">
          <Link to="/forgot-password">Pedir novo link</Link>
        </Button>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Nova senha" description="Escolha uma senha de pelo menos 8 caracteres.">
      <form
        className="flex flex-col gap-4"
        onSubmit={(event) => {
          event.preventDefault();
          void submit();
        }}
      >
        <div className="flex flex-col gap-2">
          <Label htmlFor="new-password">Senha nova</Label>
          <Input
            id="new-password"
            type="password"
            autoComplete="new-password"
            className="h-11 bg-input"
            {...form.register('newPassword')}
          />
          <FormError message={form.formState.errors.newPassword?.message} />
        </div>
        <FormError message={error} />
        <Button type="submit" className="h-11" disabled={form.formState.isSubmitting}>
          {form.formState.isSubmitting ? 'Salvando…' : 'Salvar senha'}
        </Button>
      </form>
    </AuthShell>
  );
}

export const Route = createFileRoute('/reset-password/')({
  validateSearch: searchSchema,
  component: ResetPassword,
});
